function smsmCleanDesc(html, title) {
  if (!html || !html.trim()) return { html: html || '', changed: false };
  const EMOJI = /(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[\u{1F3FB}-\u{1F3FF}⃣️︎‍✓✔✅☑•●▪▫▶►➤➡➔➜⭐★☆✨♥❤❖♦◆◇❖⬅⬆⬇⤴⤵〰〽㊗㊙])/gu;
  const doc = new DOMParser().parseFromString('<div id="r">' + html + '</div>', 'text/html');
  const root = doc.getElementById('r');
  const T = s => (s || '').replace(/\s+/g, ' ').trim();
  const tw = doc.createTreeWalker(root, 4);
  const texts = []; while (tw.nextNode()) texts.push(tw.currentNode);
  texts.forEach(n => {
    const v = n.nodeValue.replace(EMOJI, '');
    if (v !== n.nodeValue) n.nodeValue = v.replace(/^[ \t]+/, m => (n.previousSibling ? ' ' : '')).replace(/ {2,}/g, ' ');
  });
  const unwrap = el => { while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el); el.remove(); };
  root.querySelectorAll('span,font,u,mark,small,big,center').forEach(unwrap);
  root.querySelectorAll('b').forEach(b => { const s = doc.createElement('strong'); while (b.firstChild) s.appendChild(b.firstChild); b.replaceWith(s); });
  root.querySelectorAll('i').forEach(unwrap);
  root.querySelectorAll('div').forEach(d => { if (!d.querySelector('table')) unwrap(d); });
  root.querySelectorAll('*').forEach(el => {
    [...el.attributes].forEach(a => { if (!(el.tagName === 'A' && a.name === 'href') && !(el.tagName === 'IMG' && /^(src|alt)$/.test(a.name)) && !/^(colspan|rowspan)$/.test(a.name)) el.removeAttribute(a.name); });
  });
  root.querySelectorAll('li > p').forEach(p => { if (p.parentNode.children.length === 1) unwrap(p); });
  root.querySelectorAll('strong strong').forEach(unwrap);
  root.querySelectorAll('p').forEach(p => {
    const f = p.firstChild && p.firstChild.nodeType === 3 && !T(p.firstChild.nodeValue) ? p.firstChild.nextSibling : p.firstChild;
    if (f && f.tagName === 'STRONG') {
      let nx = f.nextSibling; while (nx && nx.nodeType === 3 && !T(nx.nodeValue)) nx = nx.nextSibling;
      if (nx && nx.tagName === 'BR' && T(f.textContent).length <= 45) {
        const h = doc.createElement('h4'); h.textContent = T(f.textContent);
        p.parentNode.insertBefore(h, p); f.remove(); nx.remove();
      }
    }
  });
  const TIER = /^(ال)?(مقدمة|المقدمة|القلب|قلب|القاعدة|قاعدة|المكونات العليا|مكونات القلب|المكونات الأساسية|المكونات القاعدية|النفحات العليا|النفحات الوسطى|النفحات الأساسية|مقدمة العطر|قلب العطر|قاعدة العطر|top notes|heart notes|middle notes|base notes)(?=$|[\s:|–\-،(])/i;
  const SECTION = /^(قصة|الهرم|هرم|مواصفات|المواصفات|تفاصيل|التفاصيل|لماذا|مناسب|من عالم سمسم|من سمسم|عالم سمسم|الشخصية|العائلة|طابع|المكونات|مكونات|متى|الوصف|ما الذي|ما يميز|مميزات|المميزات|طريقة|نصائح|الثبات|الفوحان|تجربة|عطور المجموعة|محتويات|ملاحظات|الاستخدام|الموسم|why|the fragrance|fragrance|product spec)/i;
  const blocks = [...root.children];
  let first = true, seenTitle = false, idx = 0;
  const isStrongOnly = el => el.tagName === 'P' && el.children.length >= 1 && [...el.childNodes].every(n => (n.nodeType === 3 && !T(n.nodeValue)) || n.tagName === 'STRONG' || n.tagName === 'BR') && T(el.textContent).length > 0;
  const mk = (tag, text, ref) => { const h = doc.createElement(tag); h.textContent = text; ref.replaceWith(h); return h; };
  blocks.forEach((el, i) => {
    const tag = el.tagName;
    const txt = T(el.textContent);
    if (!txt && !el.querySelector('img,table,iframe')) { el.remove(); return; }
    const isH = /^H[1-6]$/.test(tag);
    const so = isStrongOnly(el);
    if (idx === 0 && (isH || so)) { mk('h2', txt.replace(/[:：]\s*$/, ''), el); idx++; return; }
    if (idx === 1 && (isH || so) && /[A-Za-z]/.test(txt) && !/[؀-ۿ]/.test(txt)) {
      const p = doc.createElement('p'); const s = doc.createElement('strong'); s.textContent = txt; p.appendChild(s); el.replaceWith(p); idx++; return; }
    idx++;
    if (!(isH || so)) { if (el.lastChild && el.lastChild.nodeType===3) el.lastChild.nodeValue=el.lastChild.nodeValue.replace(/\s+$/,''); return; }
    const clean = txt.replace(/[:：]\s*$/, '').trim();
    if (TIER.test(clean) || /^\d+[.)\-–]\s/.test(clean)) { mk('h4', clean, el); return; }
    if (isH) { mk('h3', clean, el); return; }
    if (txt.length <= 50 && (/[:：]\s*$/.test(txt) || SECTION.test(clean))) { mk('h3', clean, el); return; }
  });
  root.querySelectorAll('br').forEach(br => { const p = br.parentNode; if (p === root || !br.nextSibling || (br.nextSibling.nodeType === 3 && !T(br.nextSibling.nodeValue) && !br.nextSibling.nextSibling)) br.remove(); });
  root.querySelectorAll('p,li,strong,h2,h3,h4').forEach(e => { if (!T(e.textContent) && !e.querySelector('img')) e.remove(); });

  let out = root.innerHTML.replace(/\n\s*\n/g, '\n').replace(/>\s+</g, '><');
  out = out.replace(/<\/(h2|h3|h4|p|ul|ol|table|li)>/g, '</$1>\n');
  return { html: out.trim(), changed: out.trim() !== html.trim() };
}
(function(){
  var EM=/(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[\u{1F3FB}-\u{1F3FF}⃣️‍])/gu;
  function run(){
    document.querySelectorAll('.smsm-desc').forEach(function(el){
      if(el.dataset.smsmDone) return; el.dataset.smsmDone='1';
      try{
        if(el.classList.contains('smsm-desc--plain')){
          var w=document.createTreeWalker(el,4),n;while((n=w.nextNode())){var v=n.nodeValue.replace(EM,'');if(v!==n.nodeValue)n.nodeValue=v.replace(/^\s+/,'');}
        } else { el.innerHTML = smsmCleanDesc(el.innerHTML).html; }
      }catch(e){}
    });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();
